import React from 'react';
import { CreditCard, Upload, Users, Settings, BarChart3 } from 'lucide-react';

export const SUPER_ADMIN_UIDS = ['Sp2J5aphEyfvztczzHjMt9TJk8O2']; 

// Definición centralizada de todos los permisos de la aplicación
export const ALL_PERMISSIONS = {
    managePayments: {
        label: 'Gestionar Pagos',
        icon: <CreditCard size={20} />,
        description: 'Aprobar o rechazar aportes de los usuarios.'
    },
    manageWithdrawals: {
        label: 'Gestionar Retiros',
        icon: <Upload size={20} />,
        description: 'Procesar solicitudes de retiro de fondos.'
    },
    manageUsers: {
        label: 'Gestionar Usuarios y Roles',
        icon: <Users size={20} />,
        description: 'Editar perfiles, roles y permisos de los usuarios.'
    },
    viewReports: {
        label: 'Ver Reportes',
        icon: <BarChart3 size={20} />,
        description: 'Acceder a los reportes financieros y de rendimiento.'
    },
    editSettings: {
        label: 'Editar Configuración',
        icon: <Settings size={20} />,
        description: 'Modificar la configuración global de la plataforma.'
    },
};

// --- AÑADIDO: Lista de países ---
export const countries = [ 
    "Argentina",
    "Bolivia",
    "Brasil",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Cuba",
    "Ecuador",
    "El Salvador",
    "España",
    "Guatemala",
    "Honduras",
    "México",
    "Nicaragua",
    "Panamá",
    "Paraguay",
    "Perú",
    "República Dominicana",
    "Uruguay",
    "Venezuela"
    // ... añade más países si es necesario
];